import {
    SHOW_INTALK_WIDGET,
    HIDE_INTALK_WIDGET,
    SET_INTALK_CALL_DATA,
    SET_INTALK_IFRAME_READY,
    SET_INTALK_IFRAME_URL,
    SET_CALL_IN_PROGRESS
} from '../actions/intalk';

const initialState = {
    isVisible: false,
    isIframeReady: false,
    callData: null,
    iframeUrl: null,
    isCallInProgress: false
};

const intalkReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHOW_INTALK_WIDGET:
            return {
                ...state,
                isVisible: true,
                callData: action.payload
            };
        case HIDE_INTALK_WIDGET: {
            const { data, type } = action.payload;
            if (data && type && type === 'outbound.ended') {
                if (data.user_id === state?.callData?.user_id && data.ticket_id === state?.callData?.ticket_id) {
                    return {
                        ...state,
                        isVisible: false,
                        callData: null,
                        isCallInProgress: false
                    };
                }
                return state;
            }
            return {
                ...state,
                isVisible: false,
                callData: null,
                isCallInProgress: false
            };
        }
        case SET_INTALK_CALL_DATA:
            return {
                ...state,
                callData: action.payload
            };
        case SET_INTALK_IFRAME_READY:
            return {
                ...state,
                isIframeReady: action.payload
            };
        case SET_INTALK_IFRAME_URL:
            return {
                ...state,
                iframeUrl: action.payload
            };
        case SET_CALL_IN_PROGRESS:
            return {
                ...state,
                isCallInProgress: action.payload
            };
        default:
            return state;
    }
};

export default intalkReducer;
